import component from './PriceSummary';

export default component;
